import Validators from '../validators'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
const moment = extendMoment(Moment)

export default (store) => store.createEmbededEntityState({
  lastSave: 'flyprivateCategoriesUpdate',
  timeRestriction: 'flyprivateCategories',
  attrs: ['enum_value', 'regions', 'valid_from', 'valid_to'],
  titles: [store.__('category'), store.__('region'), store.__('valid from'), store.__('valid to')],
  _sortField: 'enum_value',
  initVals: (row) => ({ control_timestamp: Math.round(new Date().getTime()) }),
  validators: {
    enum_value: [],
    regions: [
      Validators.regionTest(store)
    ],
    valid_from: [
      Validators.isValidFromTo(store)
    ],
    valid_to: [
      Validators.isValidFromTo(store)
    ],
    _global: (vals, batchItems) => {
      const overlappingIJ = i => j => {
        if (i.id === j.id ||
          i.video_id !== j.video_id ||
          i.enum_value !== j.enum_value ||
          (i.enum_value === j.enum_value && i.regions !== j.regions)) {
          return null
        }

        const iFrom = new Date(i.valid_from)
        const iTo = new Date(i.valid_to)
        const jFrom = new Date(j.valid_from)
        const jTo = new Date(j.valid_to)
        if (!((iFrom < jFrom) && (iTo < jFrom)) && !((iFrom > jTo) && (iTo > jTo))) {
          return i
        }
      }

      if (batchItems && batchItems.length > 0) {
        // if batchItems are passed than validations is called from batch
        // then valls = item which is being processed and batchItems are all Film categories
        // it run validations for item(vals) with all batchItems
        return !batchItems.filter(overlappingIJ(vals)).length // false = not passed
      }

      const updatedItems = []
      const toUpdate = [
        'enum_value',
        'regions',
        'valid_from',
        'valid_to'
      ]

      // Validate just inside batch
      // first update all items inside of batch and then run validations
      store.cv.items.map(i => {
        const toAssign = {}
        toUpdate.map(j => {
          toAssign[j] = (vals.has(j) && vals.get(j)) || (i[j] || '')
        })
        updatedItems.push(Object.assign({}, i, toAssign))
      })

      const overlapping = updatedItems.filter(i => {
        return updatedItems.filter(overlappingIJ(i)).length || null
      })

      if (overlapping.length > 0) {
        return overlapping.map((item) => {
          return `${store.__('Overlapped item (id/region/category): ')} ${item.id} / ${item.regions} / ${item.enum_value}. `
        })
      }
    }
  }
})
